import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackScheduleReminderWishListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/wishList/trackScheduleReminderWishList";

const useTrackScheduleReminderWishList = (
    parameters: TrackScheduleReminderWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.scheduleReminderWishList, parameters, options);
};

export default useTrackScheduleReminderWishList;
